<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="250"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <v-btn
          :color="(dateFrom && dateTo) || moreFilters ? 'secondary' : ''"
          slot="activator"
          icon
          v-on="on"
        >
          <v-icon>filter_list</v-icon>
        </v-btn>
        <span>Additional search options</span>
      </v-tooltip>
    </template>

    <v-card class="primary">
      <v-toolbar class="primary" flat>
        <v-toolbar-title>
          <h4>Additional Filters</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="menu = false" flat icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-flex xs12 class="mb-2">
          <v-menu
            v-model="fromMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <h3 class="px-1 pb-2">Filter by Date</h3>
              <v-text-field
                v-model="dateFrom"
                prepend-inner-icon="date_range"
                placeholder="Date From"
                color="secondary"
                class="mx-1"
                v-on="on"
                readonly
                hide-details
                single-line
                light
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              color="secondary"
              v-model="dateFrom"
              @input="fromMenu = false"
              light
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12>
          <v-menu
            v-model="toMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateTo"
                prepend-inner-icon="date_range"
                placeholder="Date To"
                color="secondary"
                class="mx-1"
                v-on="on"
                readonly
                hide-details
                single-line
                light
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              color="secondary"
              v-model="dateTo"
              @input="toMenu = false"
              light
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-divider></v-divider>
        <v-flex class="pt-3 mx-1" xs12>
          <slot></slot>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="notifyChanged()" flat small>Force Apply</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="clearDateFilters()" flat small>Clear</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "TableFilterMenu",
  props: {
    moreFilters: Boolean
  },

  data() {
    return {
      menu: false,
      fromMenu: false,
      toMenu: false,
      dateFrom: null,
      dateTo: null
    };
  },

  mounted() {
    this.$root.$on("child-changed", () => {
      this.notifyChanged();
    });
  },

  watch: {
    moreFilters() {
      this.notifyChanged();
    },

    dateTo() {
      if (this.dateFrom) this.notifyChanged();
    },

    dateFrom() {
      if (this.dateTo) this.notifyChanged();
    }
  },

  methods: {
    notifyChanged(cleared = false) {
      this.$emit("filters-changed", {
        from: this.dateFrom,
        to: this.dateTo,
        cleared
      });
    },

    clearDateFilters() {
      this.dateFrom = null;
      this.dateTo = null;
      this.notifyChanged(true);
      this.menu = false;
    }
  }
};
</script>
